import React, { Component } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import FormAddress from '../../Components/FormAddress';
import NavBtn from '../../Components/NavBtn';
import Loading from '../../Components/Loading';

import { editSubscription } from '../../_redux/actions/subscription';
import { createOrder, updateAddressOrder } from '../../_redux/actions/order';
import {
	addDeliveryAddress,
	editDeliveryAddress
} from '../../_redux/actions/address';

import TagManager from 'react-gtm-module';

import { formUtils } from '../../utils';

import { hotjar } from 'react-hotjar';
import { PageView, initGA } from '../../Components/Tracking';
import Header from '../../Components/Header';

import { ThemeProvider } from 'styled-components';
import ThemeSelector from '../../style/themes/ThemeSelector';
import FormWrapper from '../../style/styledComponents/FormWrapper';
import BoxSize from '../../style/styledComponents/BoxSize';
import StepCounter from '../../Components/StepCounter';
import Container from '../../style/styledComponents/Container';

class EnderecoCobranca extends Component {
	constructor() {
		super();

		this.formData = this.formData.bind(this);
		this.formSend = this.formSend.bind(this);
		this.errorAccept = this.errorAccept.bind(this);
		this.goBack = this.goBack.bind(this);
		this.checkErrorOnField = this.checkErrorOnField.bind(this);
		this.handleIsComplete = this.handleIsComplete.bind(this);
		this.getUtmCampaignData = this.getUtmCampaignData.bind(this);
		this.fieldsTouched = false;

		this.state = {
			error: false,
			sending: false,
			errorOnField: {},
			isComplete: false
		};
	}

	componentDidMount() {
		let { Subscription } = this.props;
		let { loja } = this.props.match.params;
		this.handleIsComplete();

		initGA('UA-120298096-1');
		PageView(`/loja/${loja}/enderecoBeneficiario`);

		hotjar.initialize(937897, 6);

		if (!Object.keys(Subscription.data.itens).length) {
			this.props.history.push(process.env.PUBLIC_URL + `/${loja}/beneficiario`);
		}

		let user = Subscription.data.itens[0];
		let name = user.name.split(' ');
		let i = 1;
		let firstName = '';
		let lastName = '';
		while (i <= name.length) {
			if (i === 1) {
				firstName = name[i - 1];
			} else {
				lastName = lastName + ' ' + name[i - 1];
			}
			i = i + 1;
		}

		lastName = lastName.trim();

		// Obtém a data/hora atual
		let date = new Date();

		let day = date.getDate(); // 1-31
		let month = date.getMonth(); // 0-11 (zero=janeiro)
		let year = date.getFullYear(); // 4 dígitos
		let hour = date.getHours(); // 0-23
		let minute = date.getMinutes(); // 0-59

		// Formata a data e a hora (note o mês + 1)
		var str_date =
			year + '-' + (month + 1) + '-' + day + ' ' + hour + ':' + minute;
		const tagManagerArgs = {
			//gtmId: 'GTM-KGG5NJS', //QA
			//gtmId: 'GTM-W642D5X',
			gtmId: process.env.REACT_APP_GTM
			// events: {
			// 	assinanteCadastrado: 'assinanteCadastrado'
			// }
		};
		let cpf = user.cpf.replace(/(\.|-)/g, '');
		let phone = user.phone.replace(' ', '');
		let gender = user.gender === 'Male' ? 'masculino' : 'feminino';
		let birthdaySplit = user.birthday.split('/');
		let birthday =
			birthdaySplit[2] + '-' + birthdaySplit[1] + '-' + birthdaySplit[0];

		TagManager.initialize(tagManagerArgs);

		const utmCampaignData = this.getUtmCampaignData();

		TagManager.dataLayer({
			dataLayer: {
				event: 'assinanteCadastrado',
				firstname: firstName,
				lastname: lastName,
				mobile: phone,
				sexo: gender,
				cpf: cpf,
				email: user.email,
				data_do_pedido: str_date,
				data_de_nascimento: birthday,
				loja: loja,
				...utmCampaignData
			}
		});
	}

	checkErrorOnField() {
		let checkDataValue = formUtils.checkAddressErrors(this.data);
		this.setState({ errorOnField: checkDataValue });
	}

	getUtmCampaignData() {
		let {
			Campaign: { wait }
		} = this.props;
		// wait.formulario_de_conversao = "pedido_iniciado"
		if (Object.keys(wait).length == 0) {
			let {
				Campaign: { info }
			} = this.props;
			console.debug('UtmCampaignDataInfo', info);
			return info;
		}
		console.debug('UtmCampaignDataWait', wait);
		return wait;
	}

	formData(data) {
		this.data = data;
	}

	goBack() {
		this.props.history.goBack();
	}

	handleIsComplete() {
		let sendData = {};
		for (let fieldItem in this.data) {
			sendData[fieldItem] = this.data[fieldItem].value;
		}
		let formData = sendData;
		let isIncomplete = false;

		for (let field in formData) {
			if (field === 'complement') {
			} else {
				if (formData[field] === undefined) {
					isIncomplete = true;
				}
			}
		}
		if (isIncomplete) {
			this.setState({
				isComplete: false
			});
		} else {
			this.setState({
				isComplete: true
			});
		}
	}

	async formSend() {
		this.fieldsTouched = true;
		this.checkErrorOnField();

		let checkDataValue = formUtils.checkData(this.data, ['complement']);

		if (checkDataValue) {
			this.setState({
				// error: checkDataValue
			});
		} else {
			this.setState({
				sending: true
			});

			let { Address } = this.props;

			let addressData = formUtils.formatData(this.data);

			if (Address.delivery.addressId) {
				await this.props.editDeliveryAddress({
					...addressData,
					addressId: Address.delivery.addressId
				});
			} else {
				await this.props.addDeliveryAddress(addressData);

				let { Address, Order } = this.props;
				await this.props.updateAddressOrder(
					Order.data.orderId,
					Address.delivery.addressId
				);
				// update all subscriptions with addressId
			}

			let { loja } = this.props.match.params;
			const {
				GiftCode,
				VivoUser,
				CmDrConsulta,
				SignatureChosen,
				Levelled
			} = this.props;

			if (
				Object.keys(GiftCode.data).length > 0 ||
				Object.keys(VivoUser.data).length > 0 ||
				Object.keys(CmDrConsulta.data).length > 0 ||
				Object.keys(SignatureChosen.data).length > 0 ||
				Object.keys(Levelled.data).length > 0
			) {
				this.props.history.push(process.env.PUBLIC_URL + `/${loja}/pagamento`);
			} else {
				this.props.history.push(process.env.PUBLIC_URL + `/${loja}/carrinho`);
			}
		}
	}

	errorAccept() {
		if (this.state.errorFunc) {
			this.state.errorFunc();
		} else {
			this.setState({
				error: null
			});
		}
	}

	render() {
		const { Address } = this.props;
		const editData = Address.delivery.addressId ? Address.delivery : {};
		let { loja } = this.props.match.params;

		const pathArray = window.location.pathname.split('/');

		return (
			<ThemeProvider theme={ThemeSelector(pathArray[2])}>
				<Loading show={this.state.sending}></Loading>
				<Container>
					<Header {...this.props} />
					<FormWrapper>
						<BoxSize>
							<div className='row '>
								<NavBtn
									goBack={this.goBack}
									goBackText={'VOLTAR'}
									goForward={false}></NavBtn>{' '}
								<StepCounter
									assinatura={false}
									assinante={false}
									pagamento={false}
									endereco={true}
								/>
							</div>

							<FormAddress
								onData={this.formData}
								errorOnField={this.state.errorOnField}
								error={this.state.error}
								errorAccept={this.errorAccept}
								initialData={editData}
								isCompleted={this.handleIsComplete}
								fieldsTouched={this.fieldsTouched}
								{...this.props}></FormAddress>

							<NavBtn
								disabled={!this.state.isComplete}
								goForward={this.formSend}
								goForwardText={'PRÓXIMO PASSO'}
								step={true}></NavBtn>
						</BoxSize>
					</FormWrapper>
				</Container>
			</ThemeProvider>
		);
	}
}

const mapStateToProps = actionObject => {
	return actionObject;
};

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			editSubscription,
			createOrder,
			updateAddressOrder,
			addDeliveryAddress,
			editDeliveryAddress
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps)(EnderecoCobranca);
